import { fastApi } from "@/redux/api/fastApi";

const trendsApi = fastApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTrends: builder.query({
      query: ({ platforms, regions, industries, brand, product }) => ({
        url: `/trends/videos?platforms=${platforms}&regions=${regions}&industries=${industries}&brand=${brand}&product=${product}`,
        method: "GET",
      }),
    }),
    // getAllTrends: builder.query({
    //   query: ({ brand, product, country }) => ({
    //     url: `/trends/videos?brand=${brand}&product=${product}&country=${country}`,
    //     method: "GET",
    //     // /trends/videos?platforms=tiktok&regions=GLOBAL&industries=Entertainment&brand=Salty&product=Watches
    //   }),
    // }),
  }),
});

export const { useGetAllTrendsQuery } = trendsApi;
